import { getBusinesses } from '../../../data/repositories/businessRepository.js';
import { transformBusinessForMap } from './transformBusinessForMap.js';

export const fetchBusinessesForMap = async (params = {}) => {
    const result = await getBusinesses(params);
    const businesses = result.data || [];
    return {
        businesses: businesses.map(transformBusinessForMap),
        hasNext: result.meta?.hasNext || false,
    };
};
